import React from 'react'
import DocumentTitle from 'react-document-title'
import docsSidebar from '../pages/processes/doc-links.yaml'
import Nav from '../components/Nav'
import Footer from '../components/Footer'
import Header from '../components/Header'
import DocSidebar from '../components/DocSidebar'
import Sticky from 'react-sticky-state'
import StickySidebar from '../components/StickySidebar'
import { render } from 'react-dom'
import { StyleRoot } from 'radium'
import VertTimeLine from '../components/VertTimeLine/VertTimeLine'
import PricingTable from '../components/PricingTable';
import PricingTable2 from '../components/PricingTable2';

import { userInfo } from 'os';

DocumentTitle.displayName = 'Document Title'

const hhsCx = 'pad-r-1 flex-box dir-column m-marg-t-2 m-marg-l-2 hhs'
const hhsACx = 'clr-white relative hhs'

class Layout extends React.Component {

  constructor(props: Object) {
    super(props)

    this.state = {
      sidebarFixed: false,
    }

    this.toggleSidebarFixed = this.toggleSidebarFixed.bind(this)
  }

  toggleSidebarFixed(fixed) {
    this.setState({
      sidebarFixed: fixed,
    })
  }

  render() {
    console.log(this.props.location.pathname);
    const timelineYesNo = this.props.location.pathname === `/about/topics_roadmap/`;
    const pricingYesNo = this.props.location.pathname === `/about/pricing/`;

    const scrollClass = {
      down: 'sticky-scroll-down',
      up: 'sticky-scroll-up',
    }

    // Callback doesn't need nav etc, so return early
    if (this.props.location.pathname === '/callback') {
      return (
        <div>
          <DocumentTitle title="ftbcAcademy" key="ftbcAcademy">
          <div>
            <div className="header-main menu-shadow bg-primary-darker pad-t-1 pad-b-1">
            </div>
            <Sticky scrollClass={scrollClass}>
              <div className="sticky" id="nav">
                <Nav meta={this.props.meta} />
              </div>
            </Sticky>
            {hasSidebar && (
              <div
                className="body-container body-doc-container"
                id="body-doc-container"
              >
                <StickySidebar
                  enter="58"
                  sidebarFixed={this.state.sidebarFixed}
                  toggleFixed={this.toggleSidebarFixed}
                >
                  <DocSidebar inline yaml={docsSidebar} />
                </StickySidebar>
                <div
                  className={
                    'doc-container ' +
                    (this.state.sidebarFixed ? 'fixed-padding' : '')
                  }
                  id="doc-container"
                >
                  {this.props.children()}
                </div>
              </div>
            )}
            {!hasSidebar && (
              <div className="body-container">{this.props.children()}</div>
            )}
            {!hasSidebar && <Footer />}
          </div>
        </DocumentTitle>
        </div>
      )
    }

    const hasSidebar = this.props.location.pathname.slice(0, 11) === `/processes/`;
    console.log(this.props.location.pathname);
   
      return (
        <DocumentTitle title="ftbcAcademy" key="ftbcAcademy">
          <div>
            <div className="header-main menu-shadow bg-primary-darker pad-t-1 pad-b-1">
              <Header/>
            </div>
            <Sticky scrollClass={scrollClass}>
              <div className="sticky" id="nav">
                <Nav meta={this.props.meta} />
              </div>
            </Sticky>
            {hasSidebar && (
              <div
                className="body-container body-doc-container"
                id="body-doc-container"
              >
                <StickySidebar
                  enter="58"
                  sidebarFixed={this.state.sidebarFixed}
                  toggleFixed={this.toggleSidebarFixed}
                >
                  <DocSidebar inline yaml={docsSidebar} />
                </StickySidebar>
                <div
                  className={
                    'doc-container ' +
                    (this.state.sidebarFixed ? 'fixed-padding' : '')
                  }
                  id="doc-container"
                >
                  {this.props.children()}
                </div>
              </div>
            )}            
            {!hasSidebar && (
              <div className="body-container">
                {this.props.children()} 
                {
                  pricingYesNo &&  (                                
                    <section className="container marg-b-3 relative row content-wrapper">
                        <table style = {{
                          border: '0px',
                        }}><tr><td>
                        <PricingTable />
                        </td><td>
                        {/* <PricingTable2 /> */}
                        </td>
                        </tr>
                        </table>                                           
                    </section> 
                  )
                }
              </div>
            )}
                               
            {timelineYesNo && (
              <StyleRoot>
              {/* <VertTimeLine activeColor='yellow'> */}
              <VertTimeLine>
                <div>
                  <time>AUGUST 2018</time><br/><br/> 
                  <ul>
                  <li style={{textAlign: 'left',}}>Introduction of Trade Lifecycle</li>
                  </ul>
                </div>
                <div>
                  <time>SEPTEMBER 2018</time><br/><br/> 
                  <ul>
                  <li style={{textAlign: 'left',}}>New Entity Setup FTBModule</li>
                  <li style={{textAlign: 'left',}}>Operating Model</li>
                  <li style={{textAlign: 'left',}}>Risk Management Model</li>
                  <li style={{textAlign: 'left',}}>Booking Model</li>
                  <li style={{textAlign: 'left',}}>Operational Support Model</li>
                  </ul>
                </div>
                <div>
                  <time>OCTOBER 2018</time><br/><br/> 
                  <ul>
                  <li style={{textAlign: 'left',}}>Control Model</li>
                  <li style={{textAlign: 'left',}}>End of Day Model</li>
                  <li style={{textAlign: 'left',}}>System Architecture Model</li>
                  </ul>
                </div>
                <div>
                  <time>NOVEMBER 2018</time><br/><br/> 
                  <ul>
                  <li style={{textAlign: 'left',}}>Products Overview</li>
                  <li style={{textAlign: 'left',}}>Processes Overview</li>
                  <li style={{textAlign: 'left',}}>Static and Market Data Overview</li>
                  <li style={{textAlign: 'left',}}>Peole Overview</li>
                  </ul>
                </div>
                <div>
                  <time>December 2018</time><br/><br/> 
                  <ul>
                  <li style={{textAlign: 'left',}}>FX Vanilla Cash Trade Lifecycle</li>
                  <li style={{textAlign: 'left',}}>MM Trade Lifecycle</li>
                  </ul>
                </div>
                {/* {[0,1,2,3,4,5,6,7,8,9,10].map(i =>
                <div key={i}>
                  <h1>{i}</h1>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                  eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                  voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
                  clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
                  amet.
                </div>
                )} */}
              </VertTimeLine>
            </StyleRoot>
            )}
            <br/><br/>
            {!hasSidebar && <Footer />}
          </div>
        </DocumentTitle>
      )
  }
}

Layout.displayName = 'Layout'
export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js